
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.667 10.667h4.666V12H4.667v-1.333zm0-2.667h6.666v1.333H4.667V8zm0-2.667h6.666v1.334H4.667V5.333zm8-2.666H9.88A2.007 2.007 0 008 1.333c-.867 0-1.6.56-1.88 1.334H3.333c-.093 0-.18.006-.266.026a1.339 1.339 0 00-.96.794A1.284 1.284 0 002 4v9.333c0 .18.04.36.107.52a1.34 1.34 0 00.96.793c.086.014.173.02.266.02h9.334c.733 0 1.333-.6 1.333-1.333V4c0-.733-.6-1.333-1.333-1.333zM8 2.5c.273 0 .5.227.5.5s-.227.5-.5.5a.504.504 0 01-.5-.5c0-.273.227-.5.5-.5zm4.667 10.833H3.333V4h9.334v9.333z","fill":"currentColor"}})])
          )
        }
      }
    